import {
  ACTION_WORKFLOW_INVOICE_POS,
  ACTION_WORKFLOW_INVOICE_POS_FAIL,
  ACTION_WORKFLOW_INVOICE_POS_SUCCESS,
  ADJUST_INVOICE_POS,
  ADJUST_INVOICE_POS_FAIL,
  ADJUST_INVOICE_POS_SUCCESS,
  ATTACK_FILE_INVOICE_POS_UPLOAD,
  ATTACK_FILE_INVOICE_POS_UPLOAD_FAIL,
  ATTACK_FILE_INVOICE_POS_UPLOAD_RESET,
  ATTACK_FILE_INVOICE_POS_UPLOAD_SUCCESS,
  BK_DATA_NEW_POS,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_FAIL,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_SUCCESS,
  CANCEL_INVOICE_POS,
  CANCEL_INVOICE_POS_FAIL,
  CANCEL_INVOICE_POS_SUCCESS,
  CLONE_ENVOICE_POS,
  CLONE_ENVOICE_POS_FAIL,
  CLONE_ENVOICE_POS_SUCCESS,
  CREATE_INVOICE_POS_ENTERPRISE,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_FAIL,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_SUCCESS,
  CREATE_INVOICE_POS_ENTERPRISE_FAIL,
  CREATE_INVOICE_POS_ENTERPRISE_SUCCESS,
  DELETE_INVOICE_POS,
  DELETE_INVOICE_POS_FAIL,
  DELETE_INVOICE_POS_SUCCESS,
  DOWNLOAD_XML_INVOICE_POS,
  DOWNLOAD_XML_INVOICE_POS_FAIL,
  DOWNLOAD_XML_INVOICE_POS_SUCCESS,
  DOWNLOAD_ZIP_INVOICE_POS,
  DOWNLOAD_ZIP_INVOICE_POS_FAIL,
  DOWNLOAD_ZIP_INVOICE_POS_SUCCESS,
  EXPORT_INVOICE_POS,
  EXPORT_INVOICE_POS_FAIL,
  EXPORT_INVOICE_POS_RESET,
  EXPORT_INVOICE_POS_SUCCESS,
  EXPORT_INVOICE_POS_TICKET,
  EXPORT_INVOICE_POS_TICKET_FAIL,
  EXPORT_INVOICE_POS_TICKET_RESET,
  EXPORT_INVOICE_POS_TICKET_SUCCESS,
  EXPORT_INVOICE_POS_WAREHOUSES,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_FAIL,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_RESET,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_SUCCESS,
  EXPORT_INVOICE_POS_WAREHOUSES_FAIL,
  EXPORT_INVOICE_POS_WAREHOUSES_RESET,
  EXPORT_INVOICE_POS_WAREHOUSES_SUCCESS,
  GENERATE_NUMBER_INVOICE_POS,
  GENERATE_NUMBER_INVOICE_POS_FAIL,
  GENERATE_NUMBER_INVOICE_POS_SUCCESS,
  GET_CURRENT_TIME_POS,
  GET_CURRENT_TIME_POS_FAIL,
  GET_CURRENT_TIME_POS_SUCCESS,
  GET_DATA_LINK_POS,
  GET_DATA_LINK_POS_FAIL,
  GET_DATA_LINK_POS_RESET,
  GET_DATA_LINK_POS_SUCCESS,
  GET_ENTERPRISE_POS_BY_TAX_CODE,
  GET_ENTERPRISE_POS_BY_TAX_CODE_FAIL,
  GET_ENTERPRISE_POS_BY_TAX_CODE_RESET,
  GET_ENTERPRISE_POS_BY_TAX_CODE_SUCCESS,
  GET_INVOICE_POS_MAX_DATE,
  GET_INVOICE_POS_MAX_DATE_FAIL,
  GET_INVOICE_POS_MAX_DATE_RESET,
  GET_INVOICE_POS_MAX_DATE_SUCCESS,
  GET_INVOICE_POS_MIN_DATE,
  GET_INVOICE_POS_MIN_DATE_FAIL,
  GET_INVOICE_POS_MIN_DATE_RESET,
  GET_INVOICE_POS_MIN_DATE_SUCCESS,
  GET_INVOICE_POS_REPORT_WORD,
  GET_INVOICE_POS_REPORT_WORD_FAIL,
  GET_INVOICE_POS_REPORT_WORD_SUCCESS,
  INVOICE_POS_CAMPAIGN_DETAIL,
  INVOICE_POS_CAMPAIGN_DETAIL_FAIL,
  INVOICE_POS_CAMPAIGN_DETAIL_RESET,
  INVOICE_POS_CAMPAIGN_DETAIL_SUCCESS,
  INVOICE_POS_CAMPAIGN_LIST,
  INVOICE_POS_CAMPAIGN_LIST_FAIL,
  INVOICE_POS_CAMPAIGN_LIST_SUCCESS,
  INVOICE_POS_CREATE,
  INVOICE_POS_CREATE_FAIL,
  INVOICE_POS_CREATE_RESET,
  INVOICE_POS_CREATE_SUCCESS,
  INVOICE_POS_DETAIL,
  INVOICE_POS_DETAIL_FAIL,
  INVOICE_POS_DETAIL_RESET,
  INVOICE_POS_DETAIL_SUCCESS,
  INVOICE_POS_EDIT,
  INVOICE_POS_EDIT_FAIL,
  INVOICE_POS_EDIT_RESET,
  INVOICE_POS_EDIT_SUCCESS,
  INVOICE_POS_LIST,
  INVOICE_POS_LIST_COLUMN,
  INVOICE_POS_LIST_FAIL,
  INVOICE_POS_LIST_RESET,
  INVOICE_POS_LIST_SALE_HAVE_CODE_COLUMN,
  INVOICE_POS_LIST_SALE_NONE_CODE_COLUMN,
  INVOICE_POS_LIST_SUCCESS,
  INVOICE_POS_LIST_VAT_NONE_CODE_COLUMN,
  LOAD_CONFIG_INVOICE_POS_FIELD,
  LOAD_CONFIG_INVOICE_POS_FIELD_FAIL,
  LOAD_CONFIG_INVOICE_POS_FIELD_RESET,
  LOAD_CONFIG_INVOICE_POS_FIELD_SUCCESS,
  PHASE_INVOICE_POS_DETAIL,
  PHASE_INVOICE_POS_DETAIL_FAIL,
  PHASE_INVOICE_POS_DETAIL_RESET,
  PHASE_INVOICE_POS_DETAIL_SUCCESS,
  PHASE_INVOICE_POS_LIST,
  PHASE_INVOICE_POS_LIST_COLUMN,
  PHASE_INVOICE_POS_LIST_FAIL,
  PHASE_INVOICE_POS_LIST_RESET,
  PHASE_INVOICE_POS_LIST_SUCCESS,
  PREVIEW_PDF_INVOICE_POS,
  PREVIEW_PDF_INVOICE_POS_FAIL,
  PREVIEW_PDF_INVOICE_POS_SUCCESS,
  RELEASE_CAMPAIGNS_INVOICE_POS,
  RELEASE_CAMPAIGNS_INVOICE_POS_FAIL,
  RELEASE_CAMPAIGNS_INVOICE_POS_RESET,
  RELEASE_CAMPAIGNS_INVOICE_POS_SUCCESS,
  RELEASE_INVOICE_POS,
  RELEASE_INVOICE_POS_FAIL,
  RELEASE_INVOICE_POS_SUCCESS,
  REMOVE_FILE_INVOICE_POS,
  REMOVE_FILE_INVOICE_POS_FAIL,
  REMOVE_FILE_INVOICE_POS_RESET,
  REMOVE_FILE_INVOICE_POS_SUCCESS,
  REPLACE_INVOICE_POS,
  REPLACE_INVOICE_POS_FAIL,
  REPLACE_INVOICE_POS_SUCCESS,
  RESET_ACTION_WORKFLOW_INVOICE_POS,
  RESET_ADJUST_INVOICE_POS,
  RESET_BK_DATA_NEW_POS,
  RESET_CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
  RESET_CANCEL_INVOICE_POS,
  RESET_CLONE_ENVOICE_POS,
  RESET_CREATE_INVOICE_POS_ENTERPRISE,
  RESET_CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
  RESET_DELETE_INVOICE_POS,
  RESET_DOWNLOAD_XML_INVOICE_POS,
  RESET_DOWNLOAD_ZIP_INVOICE_POS,
  RESET_GENERATE_NUMBER_INVOICE_POS,
  RESET_GET_INVOICE_POS_REPORT_WORD,
  RESET_PREVIEW_PDF_INVOICE_POS,
  RESET_RELEASE_INVOICE_POS,
  RESET_REPLACE_INVOICE_POS,
  RESET_SEND_MAIL_INVOICE_POS,
  RESET_TRANSFER_USB_INVOICE_POS,
  SEND_MAIL_INVOICE_POS,
  SEND_MAIL_INVOICE_POS_FAIL,
  SEND_MAIL_INVOICE_POS_SUCCESS,
  SET_COLUMN_VISIBLE_INVOICE_POS_CAMPAIGN_LIST,
  TRANSFER_USB_INVOICE_POS,
  TRANSFER_USB_INVOICE_POS_FAIL,
  TRANSFER_USB_INVOICE_POS_SUCCESS,
  UPLOAD_CAMPAIGNS_INVOICE_POS,
  UPLOAD_CAMPAIGNS_INVOICE_POS_FAIL,
  UPLOAD_CAMPAIGNS_INVOICE_POS_RESET,
  UPLOAD_CAMPAIGNS_INVOICE_POS_SUCCESS,
  UPLOAD_FILE_INVOICE_POS,
  UPLOAD_FILE_INVOICE_POS_FAIL,
  UPLOAD_FILE_INVOICE_POS_RESET,
  UPLOAD_FILE_INVOICE_POS_SUCCESS,
} from "./actionTypes";

// List Invoice Pos
export const listInvoicePos = (
  params = {},
  typeInvoicePosAnother,
  showLoading = true
) => ({
  type: INVOICE_POS_LIST,
  payload: { params },
  typeInvoicePosAnother,
  showLoading,
});

export const listInvoicePosSuccess = data => ({
  type: INVOICE_POS_LIST_SUCCESS,
  payload: data,
});

export const listInvoicePosFail = error => ({
  type: INVOICE_POS_LIST_FAIL,
  payload: error,
});

export const resetListInvoicePos = () => ({
  type: INVOICE_POS_LIST_RESET,
  payload: {},
});

// Phase List Invoice Pos
export const listPhaseInvoicePos = (params = {}, showLoading = true) => ({
  type: PHASE_INVOICE_POS_LIST,
  payload: { params },
  showLoading,
});

export const listPhaseInvoicePosSuccess = data => ({
  type: PHASE_INVOICE_POS_LIST_SUCCESS,
  payload: data,
});

export const listPhaseInvoicePosFail = error => ({
  type: PHASE_INVOICE_POS_LIST_FAIL,
  payload: error,
});

export const resetListPhaseInvoicePos = () => ({
  type: PHASE_INVOICE_POS_LIST_RESET,
  payload: {},
});

// Detail Phase Invoice Pos
export const getDetailPhaseInvoicePos = id => ({
  type: PHASE_INVOICE_POS_DETAIL,
  id,
});

export const getDetailPhaseInvoicePosSuccess = data => ({
  type: PHASE_INVOICE_POS_DETAIL_SUCCESS,
  data,
});

export const getDetailPhaseInvoicePosFail = error => ({
  type: PHASE_INVOICE_POS_DETAIL_FAIL,
  payload: error,
});
export const resetGetDetailPhaseInvoicePos = () => ({
  type: PHASE_INVOICE_POS_DETAIL_RESET,
  payload: {},
});
//

export const setListInvoicePosColumn = (field, value) => ({
  type: INVOICE_POS_LIST_COLUMN,
  payload: { field, value },
});

export const setListPhaseInvoicePosColumn = (field, value) => ({
  type: PHASE_INVOICE_POS_LIST_COLUMN,
  payload: { field, value },
});

export const setListInvoicePosVATNoneCodeColumn = (field, value) => ({
  type: INVOICE_POS_LIST_VAT_NONE_CODE_COLUMN,
  payload: { field, value },
});

export const setListInvoicePosSaleHaveCodeColumn = (field, value) => ({
  type: INVOICE_POS_LIST_SALE_HAVE_CODE_COLUMN,
  payload: { field, value },
});

export const setListInvoicePosSaleNoneCodeColumn = (field, value) => ({
  type: INVOICE_POS_LIST_SALE_NONE_CODE_COLUMN,
  payload: { field, value },
});

// Create Invoice Pos
export const createInvoicePos = (data, typeInvoicePosAnother) => ({
  type: INVOICE_POS_CREATE,
  payload: { data },
  typeInvoicePosAnother,
});

export const createInvoicePosSuccess = data => ({
  type: INVOICE_POS_CREATE_SUCCESS,
  payload: data,
});

export const createInvoicePosFail = error => ({
  type: INVOICE_POS_CREATE_FAIL,
  payload: error,
});

export const resetCreateInvoicePos = () => ({
  type: INVOICE_POS_CREATE_RESET,
  payload: {},
});

// EDIT Invoice Pos
//auto_sign int 0 => mặc định không có , 1 => có tự ký
export const editInvoicePos = (
  data,
  id,
  typeInvoicePosAnother,
  auto_sign = 0
) => ({
  type: INVOICE_POS_EDIT,
  payload: { data },
  id,
  typeInvoicePosAnother,
  auto_sign,
});

export const editInvoicePosSuccess = data => ({
  type: INVOICE_POS_EDIT_SUCCESS,
  payload: data,
});

export const editInvoicePosFail = error => ({
  type: INVOICE_POS_EDIT_FAIL,
  payload: error,
});

export const resetEditInvoicePos = () => ({
  type: INVOICE_POS_EDIT_RESET,
  payload: {},
});

// Replace Invoice Pos
export const getCloneEnvoicePos = (
  id,
  typeInvoicePosAnother,
  approveStatus
) => ({
  type: CLONE_ENVOICE_POS,
  id,
  typeInvoicePosAnother,
  approveStatus,
});

export const getCloneEnvoicePosSuccess = data => ({
  type: CLONE_ENVOICE_POS_SUCCESS,
  data,
});

export const getCloneEnvoicePosFail = error => ({
  type: CLONE_ENVOICE_POS_FAIL,
  error,
});
export const resetCloneEnvoicePos = () => ({
  type: RESET_CLONE_ENVOICE_POS,
});

// Replace Invoice Pos
export const replaceInvoicePos = (
  id_root,
  attach_ids,
  data,
  typeInvoicePosAnother,
  infoTT32
) => ({
  type: REPLACE_INVOICE_POS,
  id_root,
  attach_ids,
  data,
  typeInvoicePosAnother,
  infoTT32,
});

export const replaceInvoicePosSuccess = data => ({
  type: REPLACE_INVOICE_POS_SUCCESS,
  data,
});

export const replaceInvoicePosFail = error => ({
  type: REPLACE_INVOICE_POS_FAIL,
  error,
});

export const resetReplaceInvoicePos = () => ({
  type: RESET_REPLACE_INVOICE_POS,
});

// Adjust Invoice Pos
export const adjustInvoicePos = (
  id_root,
  attach_ids,
  adjust_mod,
  data,
  typeInvoicePosAnother
) => ({
  type: ADJUST_INVOICE_POS,
  id_root,
  attach_ids,
  adjust_mod,
  data,
  typeInvoicePosAnother,
});

export const adjustInvoicePosSuccess = data => ({
  type: ADJUST_INVOICE_POS_SUCCESS,
  data,
});

export const adjustInvoicePosFail = error => ({
  type: ADJUST_INVOICE_POS_FAIL,
  error,
});

export const resetAdjustInvoicePos = () => ({
  type: RESET_ADJUST_INVOICE_POS,
});

// Detail Invoice Pos
export const getDetailInvoicePos = (
  id,
  typeInvoicePosAnother,
  data = null,
  isAdjustDecrease = false
) => ({
  type: INVOICE_POS_DETAIL,
  id,
  typeInvoicePosAnother,
  data,
  isAdjustDecrease,
});

export const getDetailInvoicePosSuccess = data => ({
  type: INVOICE_POS_DETAIL_SUCCESS,
  data,
});

export const getDetailInvoicePosFail = error => ({
  type: INVOICE_POS_DETAIL_FAIL,
  payload: error,
});
export const resetGetDetailInvoicePos = () => ({
  type: INVOICE_POS_DETAIL_RESET,
  payload: {},
});

// List Invoice Pos
export const loadConfigInvoicePosField = () => ({
  type: LOAD_CONFIG_INVOICE_POS_FIELD,
});

export const loadConfigInvoicePosFieldSuccess = (
  businessUnitInfo,
  listCurrency,
  listVat,
  listPaymentMethod
) => ({
  type: LOAD_CONFIG_INVOICE_POS_FIELD_SUCCESS,
  businessUnitInfo,
  listCurrency,
  listVat,
  listPaymentMethod,
});

export const loadConfigInvoicePosFieldFail = error => ({
  type: LOAD_CONFIG_INVOICE_POS_FIELD_FAIL,
  error: error,
});

export const resetloadConfigInvoicePosField = () => ({
  type: LOAD_CONFIG_INVOICE_POS_FIELD_RESET,
});

// GET_ENTERPRISE_POS_BY_TAX_CODE
export const getEnterprisePosByTaxCode = taxCode => ({
  type: GET_ENTERPRISE_POS_BY_TAX_CODE,
  taxCode,
});

export const getEnterprisePosByTaxCodeSuccess = data => ({
  type: GET_ENTERPRISE_POS_BY_TAX_CODE_SUCCESS,
  data,
});

export const getEnterprisePosByTaxCodeFail = error => ({
  type: GET_ENTERPRISE_POS_BY_TAX_CODE_FAIL,
  error: error,
});

export const resetGetEnterprisePosByTaxCode = () => ({
  type: GET_ENTERPRISE_POS_BY_TAX_CODE_RESET,
});

// DOWNLOAD_XML_INVOICE_POS
export const downloadXmlInvoicePos = (
  resource_id,
  fileDownloadName,
  responseType,
  typeInvoicePosAnother,
  typeFile = ".xml"
) => ({
  type: DOWNLOAD_XML_INVOICE_POS,
  resource_id,
  fileDownloadName,
  responseType,
  typeInvoicePosAnother,
  typeFile,
});

export const downloadXmlInvoicePosSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_INVOICE_POS_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlInvoicePosFail = error => ({
  type: DOWNLOAD_XML_INVOICE_POS_FAIL,
  error,
});
export const resetDownloadXmlInvoicePos = error => ({
  type: RESET_DOWNLOAD_XML_INVOICE_POS,
});

// Phát hành hóa đơn
export const releaseInvoicePos = (
  id,
  typeSend,
  typeInvoicePosAnother,
  transferData = null,
  isCreateAdjust = false,
  idAdjust
) => ({
  type: RELEASE_INVOICE_POS,
  id,
  typeSend,
  typeInvoicePosAnother,
  transferData,
  isCreateAdjust,
  idAdjust,
});

export const releaseInvoicePosSuccess = adjustAll => ({
  type: RELEASE_INVOICE_POS_SUCCESS,
  adjustAll,
});

export const releaseInvoicePosFail = error => ({
  type: RELEASE_INVOICE_POS_FAIL,
  error,
});
export const resetReleaseInvoicePos = () => ({
  type: RESET_RELEASE_INVOICE_POS,
});

// transferUsbInvoicePos
// typeSend
// REGISTER: 1,
// INVOICE: 2,
// HDSS: 3, // Thông báo HD sai sót
// HDTH: 4, // bảng tổng hợp
// WAREHOUSES: 6, //Phiếu xuất kho
export const transferUsbInvoicePos = (id, typeSend, content) => ({
  type: TRANSFER_USB_INVOICE_POS,
  id,
  typeSend,
  content,
});

export const transferUsbInvoicePosSuccess = data => ({
  type: TRANSFER_USB_INVOICE_POS_SUCCESS,
  data,
});

export const transferUsbInvoicePosFail = error => ({
  type: TRANSFER_USB_INVOICE_POS_FAIL,
  error,
});
export const resetTransferUsbInvoicePos = error => ({
  type: RESET_TRANSFER_USB_INVOICE_POS,
});
// generateNumberInvoicePos
export const generateNumberInvoicePos = (id, typeInvoicePosAnother) => ({
  type: GENERATE_NUMBER_INVOICE_POS,
  id,
  typeInvoicePosAnother,
});

export const generateNumberInvoicePosSuccess = data => ({
  type: GENERATE_NUMBER_INVOICE_POS_SUCCESS,
  data,
});

export const generateNumberInvoicePosFail = error => ({
  type: GENERATE_NUMBER_INVOICE_POS_FAIL,
  error,
});
export const resetGenerateNumberInvoicePos = () => ({
  type: RESET_GENERATE_NUMBER_INVOICE_POS,
});

// PREVIEW_PDF_INVOICE_POS
export const previewPdfInvoicePos = (
  id,
  isPolicy = false,
  isConvert = false,
  isNoneCopy = false
) => ({
  type: PREVIEW_PDF_INVOICE_POS,
  id,
  isPolicy,
  isConvert,
  isNoneCopy,
});

// PREVIEW_PDF Success
export const previewPdfInvoicePosSuccess = data => ({
  type: PREVIEW_PDF_INVOICE_POS_SUCCESS,
  data,
});

// previewPdfInvoicePosFail
export const previewPdfInvoicePosFail = error => ({
  type: PREVIEW_PDF_INVOICE_POS_FAIL,
  error,
});

// resetPreviewFile
export const resetPreviewPdfInvoicePos = () => ({
  type: RESET_PREVIEW_PDF_INVOICE_POS,
});

// Xóa hóa đơn
export const deleteInvoicePos = (id, typeInvoicePosAnother) => ({
  type: DELETE_INVOICE_POS,
  id,
  typeInvoicePosAnother,
});

export const deleteInvoicePosSuccess = () => ({
  type: DELETE_INVOICE_POS_SUCCESS,
});

export const deleteInvoicePosFail = error => ({
  type: DELETE_INVOICE_POS_FAIL,
  error,
});
export const resetDeleteInvoicePos = () => ({
  type: RESET_DELETE_INVOICE_POS,
});

// Hủy hóa đơn
export const cancelInvoicePos = (
  listInvoice,
  typeCancel,
  typeInvoicePosAnother,
  attach_ids
) => ({
  type: CANCEL_INVOICE_POS,
  listInvoice,
  typeCancel,
  typeInvoicePosAnother,
  attach_ids,
});

export const cancelInvoicePosSuccess = () => ({
  type: CANCEL_INVOICE_POS_SUCCESS,
});

export const cancelInvoicePosFail = error => ({
  type: CANCEL_INVOICE_POS_FAIL,
  error,
});
export const resetCancelInvoicePos = () => ({
  type: RESET_CANCEL_INVOICE_POS,
});

// CallBackTaxRefusedApproval
export const callBackTaxRefusedApprovalInvoicePos = id => ({
  type: CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
  id,
});

export const callBackTaxRefusedApprovalInvoicePosSuccess = () => ({
  type: CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_SUCCESS,
});

export const callBackTaxRefusedApprovalInvoicePosFail = error => ({
  type: CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_FAIL,
  error,
});
export const resetCallbackTaxRefusedApprovalInvoicePos = () => ({
  type: RESET_CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
});

// Gửi mail hóa đơn cho khách hàng
export const sendMailInvoicePos = (id, listEmail, isInvoiceError = false) => ({
  type: SEND_MAIL_INVOICE_POS,
  id,
  listEmail,
  isInvoiceError,
});

export const sendMailInvoicePosSuccess = () => ({
  type: SEND_MAIL_INVOICE_POS_SUCCESS,
});

export const sendMailInvoicePosFail = error => ({
  type: SEND_MAIL_INVOICE_POS_FAIL,
  error,
});
export const resetSendMailInvoicePos = () => ({
  type: RESET_SEND_MAIL_INVOICE_POS,
});

// uploadAttackFileInvoicePos
export const uploadAttackFileInvoicePos = (
  file,
  type = "",
  isGlobal = false
) => ({
  type: ATTACK_FILE_INVOICE_POS_UPLOAD,
  payload: { file, type, isGlobal },
});

export const uploadAttackFileInvoicePosSuccess = id => ({
  type: ATTACK_FILE_INVOICE_POS_UPLOAD_SUCCESS,
  payload: { id },
});

export const uploadAttackFileInvoicePosFail = (error, type) => ({
  type: ATTACK_FILE_INVOICE_POS_UPLOAD_FAIL,
  payload: { error, type },
});

export const resetUploadAttackFileInvoicePos = () => ({
  type: ATTACK_FILE_INVOICE_POS_UPLOAD_RESET,
  payload: {},
});

// export biên bản
export const getInvoicePosReportWord = (id, typeReport, fileName) => ({
  type: GET_INVOICE_POS_REPORT_WORD,
  id,
  typeReport,
  fileName,
});

export const getInvoicePosReportWordSuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: GET_INVOICE_POS_REPORT_WORD_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const getInvoicePosReportWordFail = error => ({
  type: GET_INVOICE_POS_REPORT_WORD_FAIL,
  error,
});

export const resetGetInvoicePosReportWord = () => ({
  type: RESET_GET_INVOICE_POS_REPORT_WORD,
});

// Work flow invoice
// SUBMIT/APPROVE/REJECT
export const actionWorkflowInvoicePos = (id, typeWorkflow, note) => ({
  type: ACTION_WORKFLOW_INVOICE_POS,
  id,
  typeWorkflow,
  note,
});

export const actionWorkflowInvoicePosSuccess = typeWorkflow => ({
  type: ACTION_WORKFLOW_INVOICE_POS_SUCCESS,
  typeWorkflow,
});

export const actionWorkflowInvoicePosFail = (error, typeWorkflow) => ({
  type: ACTION_WORKFLOW_INVOICE_POS_FAIL,
  error,
  typeWorkflow,
});

export const resetActionWorkflowInvoicePos = () => ({
  type: RESET_ACTION_WORKFLOW_INVOICE_POS,
});

// Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
export const createInvoicePosEnterprise = (id, typeClone) => ({
  type: CREATE_INVOICE_POS_ENTERPRISE,
  id,
  typeClone,
});

export const createInvoicePosEnterpriseSuccess = data => ({
  type: CREATE_INVOICE_POS_ENTERPRISE_SUCCESS,
  data,
});

export const createInvoicePosEnterpriseFail = error => ({
  type: CREATE_INVOICE_POS_ENTERPRISE_FAIL,
  error,
});

export const resetCreateInvoicePosEnterprise = () => ({
  type: RESET_CREATE_INVOICE_POS_ENTERPRISE,
});

// Tạo hóa đơn điều chỉnh giảm 100%
export const createInvoicePosEnterpriseAdjustAll = id => ({
  type: CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
  id,
});

export const createInvoicePosEnterpriseAdjustAllSuccess = data => ({
  type: CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_SUCCESS,
  data,
});

export const createInvoicePosEnterpriseAdjustAllFail = error => ({
  type: CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_FAIL,
  error,
});

export const resetCreateInvoicePosEnterpriseAdjustAll = () => ({
  type: RESET_CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
});

// upload biên bản đính kèm cho hóa đơn
export const uploadFileInvoicePos = (root_id, attach_ids) => ({
  type: UPLOAD_FILE_INVOICE_POS,
  root_id,
  attach_ids,
});

export const uploadFileInvoicePosSuccess = () => ({
  type: UPLOAD_FILE_INVOICE_POS_SUCCESS,
});

export const uploadFileInvoicePosFail = error => ({
  type: UPLOAD_FILE_INVOICE_POS_FAIL,
  error,
});

export const resetUploadFileInvoicePos = () => ({
  type: UPLOAD_FILE_INVOICE_POS_RESET,
});

// Xóa biên bản đính kèm
export const removeFileInvoicePos = id => ({
  type: REMOVE_FILE_INVOICE_POS,
  id,
});

export const removeFileInvoicePosSuccess = id => ({
  type: REMOVE_FILE_INVOICE_POS_SUCCESS,
  id,
});

export const removeFileInvoicePosFail = error => ({
  type: REMOVE_FILE_INVOICE_POS_FAIL,
  error,
});

export const resetRemoveFileInvoicePos = () => ({
  type: REMOVE_FILE_INVOICE_POS_RESET,
});

// Xuất hóa đơn
export const exportInvoicePos = (
  dataExport,
  fileName,
  path,
  invoiceReportType
) => ({
  type: EXPORT_INVOICE_POS,
  dataExport,
  fileName,
  path,
  invoiceReportType,
});

export const exportInvoicePosSuccess = (
  fileDownload,
  fileDownloadName,
  reportId
) => ({
  type: EXPORT_INVOICE_POS_SUCCESS,
  fileDownload,
  fileDownloadName,
  reportId,
});

export const exportInvoicePosFail = error => ({
  type: EXPORT_INVOICE_POS_FAIL,
  error,
});

export const resetExportInvoicePos = () => ({
  type: EXPORT_INVOICE_POS_RESET,
});

//Xuất tem phiếu
export const exportInvoicePosTicket = (dataExport, fileName) => ({
  type: EXPORT_INVOICE_POS_TICKET,
  dataExport,
  fileName,
});

export const exportInvoicePosTicketSuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: EXPORT_INVOICE_POS_TICKET_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const exportInvoicePosTicketFail = error => ({
  type: EXPORT_INVOICE_POS_TICKET_FAIL,
  error,
});

export const resetExportInvoicePosTicket = () => ({
  type: EXPORT_INVOICE_POS_TICKET_RESET,
});

// Phiếu xuất kho kiêm vận chuyển nội bộ
export const exportInvoicePosWarehouses = (dataExport, fileName) => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES,
  dataExport,
  fileName,
});

export const exportInvoicePosWarehousesSuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const exportInvoicePosWarehousesFail = error => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_FAIL,
  error,
});

export const resetExportInvoicePosWarehouses = () => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_RESET,
});

// Xuất phiếu xuất kho gửi bán đại lý
export const exportInvoicePosWarehousesAgency = (dataExport, fileName) => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_AGENCY,
  dataExport,
  fileName,
});

export const exportInvoicePosWarehousesAgencySuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const exportInvoicePosWarehousesAgencyFail = error => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_FAIL,
  error,
});

export const resetExportInvoicePosWarehousesAgency = () => ({
  type: EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_RESET,
});

// Danh sách bảng thống kê
export const getInvoicePosCampaignList = params => ({
  type: INVOICE_POS_CAMPAIGN_LIST,
  params,
});

export const getInvoicePosCampaignListSuccess = (listData, totalCount) => ({
  type: INVOICE_POS_CAMPAIGN_LIST_SUCCESS,
  listData,
  totalCount,
});

export const getInvoicePosCampaignListFail = error => ({
  type: INVOICE_POS_CAMPAIGN_LIST_FAIL,
  error,
});

export const resetInvoicePosCampaignList = error => ({
  type: INVOICE_POS_CAMPAIGN_LIST,
});

export const setColumnVisibleInvoicePosCampaignList = (field, value) => ({
  type: SET_COLUMN_VISIBLE_INVOICE_POS_CAMPAIGN_LIST,
  field,
  value,
});

// upload lô hóa đơn
export const uploadCampaignsInvoicePos = (
  typeReport,
  report_id,
  store_code
) => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_POS,
  typeReport,
  report_id,
  store_code,
});

export const uploadCampaignsInvoicePosSuccess = data => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_POS_SUCCESS,
  data,
});

export const uploadCampaignsInvoicePosFail = error => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_POS_FAIL,
  error,
});

export const resetUploadCampaignsInvoicePos = () => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_POS_RESET,
});

// Phát hành lô hóa đơn
export const releaseCampaignsInvoicePos = id => ({
  type: RELEASE_CAMPAIGNS_INVOICE_POS,
  id,
});

export const releaseCampaignsInvoicePosSuccess = () => ({
  type: RELEASE_CAMPAIGNS_INVOICE_POS_SUCCESS,
});

export const releaseCampaignsInvoicePosFail = error => ({
  type: RELEASE_CAMPAIGNS_INVOICE_POS_FAIL,
  error,
});

export const resetReleaseCampaignsInvoicePos = () => ({
  type: RELEASE_CAMPAIGNS_INVOICE_POS_RESET,
});

// Detail lô hóa đơn
export const invoicePosCampaignDetail = id => ({
  type: INVOICE_POS_CAMPAIGN_DETAIL,
  id,
});

export const invoicePosCampaignDetailSuccess = data => ({
  type: INVOICE_POS_CAMPAIGN_DETAIL_SUCCESS,
  data,
});

export const invoicePosCampaignDetailFail = error => ({
  type: INVOICE_POS_CAMPAIGN_DETAIL_FAIL,
  error,
});

export const resetInvoicePosCampaignDetail = () => ({
  type: INVOICE_POS_CAMPAIGN_DETAIL_RESET,
});

// Get thông tin child/parent của hóa đơn thay thế/ điều chỉnh
export const getDataLinkPos = (id, isGetChild = false) => ({
  type: GET_DATA_LINK_POS,
  id,
  isGetChild,
});

export const getDataLinkPosSuccess = (data, isGetChild) => ({
  type: GET_DATA_LINK_POS_SUCCESS,
  data,
  isGetChild,
});

export const getDataLinkPosFail = error => ({
  type: GET_DATA_LINK_POS_FAIL,
  error,
});

export const resetGetDataLinkPos = () => ({
  type: GET_DATA_LINK_POS_RESET,
});

// getInvoicePosMaxDate
export const getInvoicePosMaxDate = (khmhdon, khhdon, bu_code) => ({
  type: GET_INVOICE_POS_MAX_DATE,
  khmhdon,
  khhdon,
  bu_code,
});

export const getInvoicePosMaxDateSuccess = data => ({
  type: GET_INVOICE_POS_MAX_DATE_SUCCESS,
  data,
});

export const getInvoicePosMaxDateFail = error => ({
  type: GET_INVOICE_POS_MAX_DATE_FAIL,
  error,
});

export const resetGetInvoicePosMaxDate = () => ({
  type: GET_INVOICE_POS_MAX_DATE_RESET,
});

// getInvoicePosMinDate
export const getInvoicePosMinDate = (khmhdon, khhdon, bu_code) => ({
  type: GET_INVOICE_POS_MIN_DATE,
  khmhdon,
  khhdon,
  bu_code,
});

export const getInvoicePosMinDateSuccess = data => ({
  type: GET_INVOICE_POS_MIN_DATE_SUCCESS,
  data,
});

export const getInvoicePosMinDateFail = error => ({
  type: GET_INVOICE_POS_MIN_DATE_FAIL,
  error,
});

export const resetGetInvoicePosMinDate = () => ({
  type: GET_INVOICE_POS_MIN_DATE_RESET,
});

// downloadZipInvoicePos
export const downloadZipInvoicePos = (
  ids,
  typeFile, // pdf , xml,
  fileName
) => ({
  type: DOWNLOAD_ZIP_INVOICE_POS,
  ids,
  typeFile,
  fileName,
});

export const downloadZipInvoicePosSuccess = (
  fileDownload,
  fileDownloadName,
  dataResponse
) => ({
  type: DOWNLOAD_ZIP_INVOICE_POS_SUCCESS,
  fileDownload,
  fileDownloadName,
  dataResponse,
});

export const downloadZipInvoicePosFail = error => ({
  type: DOWNLOAD_ZIP_INVOICE_POS_FAIL,
  error,
});

export const resetDownloadZipInvoicePos = () => ({
  type: RESET_DOWNLOAD_ZIP_INVOICE_POS,
});

export const backupDataNewPos = data => ({
  type: BK_DATA_NEW_POS,
  data,
});

export const resetBackupDataNewPos = () => ({
  type: RESET_BK_DATA_NEW_POS,
});

// Lấy ngày hiện tại theo giờ hệ thống
export const getCurrentTimePos = () => ({
  type: GET_CURRENT_TIME_POS,
});

export const getCurrentTimePosSuccess = data => ({
  type: GET_CURRENT_TIME_POS_SUCCESS,
  data,
});

export const getCurrentTimePosFail = error => ({
  type: GET_CURRENT_TIME_POS_FAIL,
  error,
});
